module.exports = __webpack_public_path__ + "static/media/earth.efd1b14e.png";